export default {
  title: 'Votre propre domaine',
  description:
    "Faites fonctionner les applications de votre équipe sur un domaine qui vous appartient plutôt que sur l'adresse partagée. Connectez le domaine une seule fois : le tableau de bord, le portail de commandes, l'éditeur de site et le studio de site reçoivent chacun une adresse sous ce domaine.",
  read_only_description:
    'Le domaine sur lequel ce partenaire fait fonctionner ses applications. Seul le partenaire peut le connecter ou le déconnecter.',
  read_only_empty: "Ce partenaire n'a connecté aucun domaine.",
  not_connected: {
    label: 'Domaine',
    hint: 'Le domaine qui vous appartient, sans www — par exemple votremarque.fr. Ajoutez ensuite chez votre fournisseur de domaine les enregistrements DNS affichés.',
    placeholder: 'votremarque.fr',
    connect: 'Connecter',
  },
  apps: {
    dashboard: 'Tableau de bord',
    oms: 'Portail de commandes',
    storefront: 'Éditeur de site',
    website_studio: 'Studio de site',
  },
  status: {
    active: 'En ligne',
    pending: 'En attente du DNS',
    failed: 'Action requise',
    disabled: 'Déconnecté',
  },
  records: {
    title: 'Ajoutez ces enregistrements DNS pour {{root}} chez votre fournisseur de domaine',
  },
  instructions: {
    title: 'Comment ajouter les enregistrements',
    step_provider:
      'Connectez-vous là où le DNS de {{root}} est géré — en général chez le fournisseur auprès duquel vous avez acheté le domaine, ou chez un service DNS comme Cloudflare.',
    step_add:
      'Ouvrez les paramètres DNS de {{root}} et ajoutez chaque enregistrement ci-dessous : choisissez le type, puis copiez le nom et la valeur tels quels. Laissez le TTL à sa valeur par défaut.',
    step_check:
      "Enregistrez, puis cliquez sur « {{button}} ». La plupart des fournisseurs publient les modifications en quelques minutes ; certains mettent jusqu'à 48 heures.",
    tip_name:
      "Dans le champ du nom, la plupart des fournisseurs n'attendent que la partie avant {{root}}, affichée en gras. Si le vôtre demande le nom complet, copiez celui affiché en dessous.",
    tip_cloudflare:
      'Sur Cloudflare, passez les enregistrements CNAME en « DNS uniquement » (nuage gris). Un enregistrement proxifié masque le CNAME : le domaine ne peut alors pas être vérifié.',
    tip_existing:
      'Ne modifiez pas vos enregistrements existants pour {{root}} et www : votre site continue de fonctionner comme avant.',
  },
  summary: {
    live: 'Votre tableau de bord est en ligne sur {{host}}.',
    pending:
      "Nous vérifions régulièrement vos enregistrements DNS. Les nouveaux enregistrements peuvent mettre jusqu'à 48 heures à être trouvés.",
    failed:
      "Certains enregistrements n'ont pas pu être vérifiés. Corrigez les enregistrements signalés ci-dessous, puis vérifiez à nouveau.",
    relogin:
      "Dès que {{host}} est en ligne, votre équipe s'y connecte. Lors de la première visite, une nouvelle connexion sera demandée.",
  },
  buttons: {
    check_again: 'Vérifier à nouveau',
    disconnect: 'Déconnecter',
    retry: 'Réessayer',
  },
  disconnect_confirm: {
    title: 'Déconnecter {{root}} ?',
    description: "Vos applications reviennent à l'adresse partagée, et les liens sur {{root}} cessent de fonctionner.",
    ok: 'Déconnecter',
  },
  toasts: {
    load_error: 'Impossible de charger votre domaine.',
    load_error_read_only: 'Impossible de charger le domaine de ce partenaire.',
    connected: 'Domaine connecté. Ajoutez les enregistrements DNS ci-dessous.',
    connect_failed: 'Impossible de connecter le domaine.',
    check_started: 'Vérification de vos enregistrements DNS en cours.',
    check_failed: 'Impossible de lancer la vérification. Réessayez dans une minute.',
    disconnected: 'Domaine déconnecté.',
    disconnect_failed: 'Impossible de déconnecter le domaine.',
  },
};
